import { Box, Typography, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme/theme"
import { mockTriageDays } from "../../data/mockData";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import Header from "../../components/Header";

const Triage = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const columns = [
        { field: "id", headerName: "ID" },
        { field: "monday", headerName: "Monday" },
        { field: "tuesday", headerName: "Tuesday",},
        { field: "wednesday", headerName: "Wednesday",},
        { field: "thursday", headerName: "Thursday",},
        { field: "friday", headerName: "Friday",},
    ];

    return (
        <Box m="20px">
            <Header title="TRIAGE DAYS" subtitle="Who is on triage today?" />
            <Box m="40px 0 0 0" height="15vh">
                <DataGrid
                    rows={mockTriageDays}
                    columns={columns}
                />
            </Box>
        </Box>
    )
}

export default Triage;